import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import is from '@sindresorhus/is';
import createThemedComponent from '../../../theming/utils/createThemedComponent';
import { LogoWrapper } from './Logo.styles';
/**
 *
 * Themable logo component that takes in a src (either a path to an image or a react component
 * representing an svg image generated via svgr) and returns a logo with the desired image
 *
 * ```js
 * import { Logo } from '@minerva-analytics/pantheon';
 *
 * // with a png
 * import minerva_logo_png from './assets/minerva_logo.png'
 * <Logo src={minerva_logo_png} />
 *
 * // with an svg
 * import minerva_logo_svg from './SVGIcon'
 * <Logo src={minerva_logo_svg} />
 * ```
 * **Default Styles**
 *
 * To view the component's styling directly, see [Logo.styles.js](https://git.cogolo.net/minerva/pantheon/blob/master/src/components/elements/Logo/Logo.styles.js)
 *
 */

export var LogoComponent = function LogoComponent(props) {
  var src = props.src,
      rest = _objectWithoutPropertiesLoose(props, ["src"]);

  if (is.function(src)) {
    return /*#__PURE__*/React.createElement(LogoWrapper, _extends({
      as: src
    }, rest));
  }

  return /*#__PURE__*/React.createElement(LogoWrapper, _extends({
    src: src
  }, rest));
};
var Logo = createThemedComponent('Logo', LogoComponent);
export default Logo;